import Cookies from "js-cookie";
import axios from "axios";
import { detectMobile, logoutAllDevices } from "./utils";

const timeout = 60000;

export default function makeAjaxRequest(params) {
  const accessToken = Cookies.get("rec_access_token") || "";
  let recDeviceId = "";
  if (process.browser) {
    recDeviceId = Cookies.get("recDeviceId");
  }
  // const accessToken = process.env.REACT_APP_ACCESS_TOKEN;

  switch (params.method) {
    case "GET":
      return axios({
        url: params.url,
        method: "get",
        timeout: timeout,
        headers: {
          ...(params.auth && { Authorization: accessToken }),
          source: "WEB",
          "device-source": detectMobile() ? "M-site" : "Desktop",
          "device-id": recDeviceId,
          ...(params.customHeaders && params.customHeaders)
        },
        params: params.queryParams
      }).catch(err => {
        logoutAllDevices(err);
      });

    case "POST":
      return axios({
        url: params.url,
        method: "post",
        timeout: timeout,
        headers: {
          Authorization: accessToken || undefined,
          source: params.source ? params.source : "WEB",
          "device-id": recDeviceId,
          "device-source": detectMobile() ? "M-site" : "Desktop",
          ...(params.allowDuplicate && {
            "allow-duplicate": params.allowDuplicate
          }),
          ...(params.customHeaders && params.customHeaders)
        },
        data: params.data
      }).catch(err => {
        logoutAllDevices(err);
      });

    case "POST_NO_AUTH":
      return axios({
        url: params.url,
        method: "post",
        timeout: timeout,
        headers: {
          source: "WEB",
          "device-id": recDeviceId,
          "device-source": detectMobile() ? "M-site" : "Desktop",
          ...(params.customHeaders && params.customHeaders)
        },
        data: params.data
      }).catch(err => {
        const { isLogoutAllDevices = true } = params;
        logoutAllDevices(err, isLogoutAllDevices);
      });

    default:
      return false;
  }
}
